import { Component } from '@angular/core';
import { DisplayableItemsComponent } from '../../../../../shared/components/displayable-content/displayable-items/displayable-items.component';
import { WebProductTemplatesViewModel } from './web-product-templates-view-model';

@Component({
  selector: 'app-web-product-templates',
  templateUrl: './web-product-templates.component.html',
  styleUrls: ['./web-product-templates.component.scss'],
  providers: [WebProductTemplatesViewModel],
  standalone: false
})
export class WebProductTemplatesComponent extends DisplayableItemsComponent {
  constructor(public override viewModel: WebProductTemplatesViewModel) {
    super(viewModel);
  }
}
